<!-- 首页 挽留优惠券底部倒计时 -->
<template>
  <div 
    class="retain-count-down" 
    data-sensors-exposure-event-name="Element_Exposure"  
    data-sensors-exposure-property-caseId="retain_count_down"
    :data-sensors-exposure-property-caseBizType="oldPreviewFloatViewResp.caseBizType"
    v-if="showCountDown"
  >
    <span v-if="oldPreviewFloatViewResp.caseBizType === 'OLD_PREVIEW_B'">99%高通资方通道即将失效{{ oldPreviewFloatViewResp.discountType }}</span>
    <span v-else>您的{{oldPreviewFloatViewResp.discountValue}}<template v-if="oldPreviewFloatViewResp.discountType==='FREE_DAY'">天</template><template v-else>元</template>免息券即将失效</span>
    <van-count-down
      ref="countDown"
      :time="countDownSeconds"
      @finish="countDownEnd"
      millisecond
    >
      <template #default="timeData">
        {{ timeFormat(timeData.hours) }}:{{ timeFormat(timeData.minutes) }}:{{ timeFormat(timeData.seconds) }}.{{ Math.floor(timeData.milliseconds/100) }}
      </template>
    </van-count-down>
    <span @click="handleBtn" class="retain_count_down_bottom" :class="[oldPreviewFloatViewResp.caseBizType]" data-sensors-click>去使用 ></span>
    <!-- <i class="close" @click="close"></i> -->
  </div>
</template>

<script>
import { setKey } from '@/assets/utils'
export default {
  props: {
    oldPreviewFloatViewResp: {}
  },
  data () {
    return {
      showCountDown: false,
      INTERVALDAY: ''
    }
  },
  computed: {
    couponEndTime () {
      return this.oldPreviewFloatViewResp.expTime
    },
    
    countDownSeconds () {
      return Math.floor((this.couponEndTime - Date.now()))
    }
     
  },
  mounted () {
    if (this.oldPreviewFloatViewResp.caseBizType === 'OLD_PREVIEW_B' && (this.isIntervalDay(`OLD_PREVIEW_B`, 1))) {
      this.INTERVALDAY = 'OLD_PREVIEW_B'
    }
    if (this.oldPreviewFloatViewResp.discountType === 'FREE_DAY' && (this.isIntervalDay(`OLD_PREVIEW_FREE_DAY`, 1))) {
      this.INTERVALDAY = 'OLD_PREVIEW_FREE_DAY'
    }
    if (this.oldPreviewFloatViewResp.discountType === 'FREE_AMOUNT' && (this.isIntervalDay(`OLD_PREVIEW_AMOUNT`, 1))) {
      this.INTERVALDAY = 'OLD_PREVIEW_AMOUNT'
    }
    if (this.INTERVALDAY) {
      this.showCountDown = true
    }
  },
  methods: {
    handleBtn () {
      const query = {
        skipType: 'TMD_WITHDRAW'
      }
      const { bizVal } = this.oldPreviewFloatViewResp
      if (bizVal) {
        query.couponSerialNo = bizVal
        query.cacheCouponSerialNo = 'Y'
      }
      this.$router.push({
        path: '/middle/coupon',
        query
      })
    },
    close () {
      setKey(this.INTERVALDAY, Date.now())
      this.showCountDown = false
    },
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    countDownEnd () {
      this.$emit('countDownEnd')
      this.showCountDown = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

 .retain-count-down {
  position: fixed;
  height: 80px;
  background: rgba(0,0,0,0.8);
  bottom:calc(env(safe-area-inset-bottom) + 96px) ;
  left:50%;
  transform: translateX(-50%);
  width: 10rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  padding-left: 40px;
  .van-count-down{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #fff;
    line-height: 33px;
    width: 170px;
    height: 50px;
    background: #C92E10;
    border-radius: 25px;
    display: flex;
    padding-left: 18px;
    align-items: center;
    margin-left: 4px;
    margin-right: 25px;
  }
  .close {
    position: absolute;
    right: 0;
    top:0;
    width: 50px;
    height: 100%;
    background: url('./btn_close@2x.png') no-repeat 15px 15px;
    background-size: 24px 24px;
  }
 }
</style>